import {Service} from "@/apiServices/Service";

export class TipoMovimientoService extends Service {
    constructor() {
        super('tipomovimiento/');
        this.fieldPrimaryKey = 'id_tipo_movimiento';
    }

    forSelect(aFavor) {
        this.onStart();
        return this.http.get(this.getUrl('forSelect', {aFavor}))
            .then(r => this.onData(r))
            .then(response => {
                this.data = response.data;
                return this.data;
            })
            .catch(this.onError)
            .finally(() => {
                this.onFinaly();
            })
    }

    obtenerTiposReembolso() {
        this.onStart();
        return this.http.get(this.getUrl(['tipo','reembolso']))
            .then(r => this.onData(r))
            .then(response => {
                this.data = response.data;
                return this.data;
            })
            .catch(this.onError)
            .finally(() => {
                this.onFinaly();
            })
    }


    obtenerTiposMovimientoPorMovimiento() {
        this.onStart();
        return this.http.get(this.getUrl(['listar','tiposMovimientos']))
            .then(r => this.onData(r))
            .then(response => {
                this.data = response.data;
                return this.data;
            })
            .catch(this.onError)
            .finally(() => {
                this.onFinaly();
            })
    }
}
